$(function(){

  // ハンバーガーメニュー
  $('.header__trigger').click(function(){
    $(this).toggleClass('active');
    $('.overlay').fadeToggle();

    if ($(this).hasClass('active')) {
        $('.globalMenuSp').addClass('active');
    } else {
        $('.globalMenuSp').removeClass('active');
    }
  });

  $('a[href*="#"]').on('click', function() {  
    $('.globalMenuSp').removeClass('active');
    if ($('.header__trigger').hasClass('active')) {
        $('.header__trigger').removeClass('active');
    }
    
    let speed = 500;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;

  });
  
  // スクロールでその場フェードイン
  $(window).scroll(function(){
    $('.fadeIn').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      if(scroll > elemPos - windowHeight + 50){
        $(this).addClass('scrollIn');
      }
    });
  });

  // スクロールで下からフェードイン
  $(window).scroll(function(){
    $('.fadeUp').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      if(scroll > elemPos - windowHeight + 50){
        $(this).addClass('scrollUp');
      }
    });
  });

  // スクロールで下からフェードイン その２
  $(window).scroll(function(){
    $('.fadeUp02').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      if(scroll > elemPos - windowHeight + 100){
        $(this).addClass('scrollUp02');
      }
    });
  });

  // スクロールで下からフェードイン その３
  $(window).scroll(function(){
    $('.fadeUp03').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      if(scroll > elemPos - windowHeight + 150){
        $(this).addClass('scrollUp03');
      }
    });
  });

  // スクロールで左からフェードイン
  $(window).scroll(function(){
    $('.fadeLeft').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      if(scroll > elemPos - windowHeight + 50){
        $(this).addClass('scrollLeft');
      }
    });
  });

});

